import { render, staticRenderFns } from "./studentsAttendanceMarkingForm.vue?vue&type=template&id=1848e0fa"
import script from "./studentsAttendanceMarkingForm.vue?vue&type=script&lang=js"
export * from "./studentsAttendanceMarkingForm.vue?vue&type=script&lang=js"
import style0 from "./studentsAttendanceMarkingForm.vue?vue&type=style&index=0&id=1848e0fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports